import { v4 } from "uuid";
import { Spacer } from "../widget-builder.model";

export default function spacer(): Spacer {
  return {
    id: v4(),
    type: 'spacer',
    size: 15,
  }
}